import { InfoFill, OpenNewWindow16 } from 'ui/icons';
import { SecondaryButton } from 'ui/button';
import { GlobalSms as GlobalSmsIcon } from 'ui/illustrations';
import { PAGE_HEADER_VARIANTS } from 'ui/pageHeader/constants';
import { DISPLAY_CONTENT, NAVIGATION } from '../constants';
import { InfoBanner, StyledPageHeader, Title } from './styles';

const { breadcrumbLabel, documentationLinkLabel, headerTitle, infoBannerText } =
  DISPLAY_CONTENT.pageHeader;
const { projectSettingsPath, documentationPath } = NAVIGATION;

const breadcrumb = {
  content: breadcrumbLabel,
  href: projectSettingsPath,
};
const documentationLink = {
  content: (
    <SecondaryButton>
      {documentationLinkLabel} <OpenNewWindow16 />
    </SecondaryButton>
  ),
  href: documentationPath,
};

export const PageHeader = () => (
  <>
    <StyledPageHeader
      data-test="global-sms-settings-page-header"
      breadcrumb={breadcrumb}
      documentation={documentationLink}
      variant={PAGE_HEADER_VARIANTS.SECONDARY}
      isAngularLink
    >
      <Title data-test="global-sms-settings-page-header-title">
        <GlobalSmsIcon />
        {headerTitle}
      </Title>
    </StyledPageHeader>
    <InfoBanner data-test="global-sms-settings-page-header-info-banner">
      <InfoFill isColorInherited />
      {infoBannerText}
    </InfoBanner>
  </>
);
